import React from "react";
import "./AboutUs.css";


const AboutUs = () => {
  const TeamPhoto = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo1.jpg";
  const MissionPhoto = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/gallery/photo10.jpg";

  return (
    <section className="about-us-section">
      <div className="about-us-container">
        {/* Who We Are Section */}
        <h3 className="about-us-small-title">About Us</h3>
        <h1 className="about-us-main-title">Who We Are</h1>
        <p className="about-us-section-subtitle">
          Learn more about our journey, our vision, and the values that define us.
        </p>
        <div className="who-we-are">
          <div className="image-wrapper">
            <img src={TeamPhoto} alt="About Us" className="about-image" />
          </div>
          <div className="content">
            <p>
              FC Gladiators Bournemouth is a professional football team founded
              in 2022 by Dragos Craciun. Based in the beautiful coastal town of
              Bournemouth, England, the team has made a significant impact on
              the football scene in a short span of time.
              <br />
              <br />
              The team's vibrant colors, purple and yellow, are a reflection of
              their energetic and dynamic playing style. FC Gladiators
              Bournemouth plays in the prestigious WePlayFootball England
              league, where they have already made a mark by winning two
              titles.
              <br />
              <br />
              The team's impressive performance has also earned them a spot in
              the Tournament 5plus1uk at Daventry, where they finished an
              impressive third place. With their sights set on even greater
              heights, FC Gladiators Bournemouth is a team to watch out for in
              the world of football.
              <br />
              <br />
              Under the guidance of our founder Dragos Craciun, the team is
              committed to developing young talent and promoting fair play and
              sportsmanship. With their passion for the game and their
              dedication to excellence, FC Gladiators Bournemouth is poised to
              make a lasting impact on the football world.
            </p>
          </div>
        </div>

        {/* Our Mission Section */}
        <h1 className="main-title">Our Mission</h1>
        <div className="our-mission">
          <div className="content">
            <ul className="mission-list">
              <li>
                <strong>Develop Young Talent</strong>
                <p>
                  Nurture and support emerging players, creating opportunities
                  for growth and success in professional football.
                </p>
              </li>
              <li>
                <strong>Promote Fair Play and Sportsmanship</strong>
                <p>
                  Uphold the principles of integrity, respect, and fairness both
                  on and off the field.
                </p>
              </li>
              <li>
                <strong>Inspire a Passion for Football</strong>
                <p>
                  Embody an energetic and dynamic playing style that resonates
                  with fans and aspiring players.
                </p>
              </li>
              <li>
                <strong>Represent Bournemouth with Pride</strong>
                <p>
                  Highlight the coastal town’s identity through their
                  achievements and community involvement.
                </p>
              </li>
              <li>
                <strong>Foster Team Spirit and Unity</strong>
                <p>
                  Build a cohesive team culture that emphasizes collaboration
                  and shared goals.
                </p>
              </li>
            </ul>
          </div>
          <div className="image-wrapper">
            <img src={MissionPhoto} alt="Our Mission" className="mission-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
